import { toggle_loader, disable_loader } from './loader.js';
document.addEventListener('DOMContentLoaded', function () {
  var revealInstallerForm = function revealInstallerForm() {
    if (!document.querySelector('.installer-form-block')) return;
    document.body.classList.remove('loading', 'installers-loading');
  };

  revealInstallerForm();
  window.addEventListener('pageshow', revealInstallerForm);

  var setSwatchState = function setSwatchState(targetName, value, scope) {
    var allToggles = (scope || document).querySelectorAll('.installer-swatch-toggle[data-target="' + targetName + '"]');
    allToggles.forEach(function (toggle) {
      var isActive = toggle.dataset.value === value;
      toggle.classList.toggle('active', isActive);
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  var updateGloUrl = function updateGloUrl(targetName, value) {
    if (!['glo_colour', 'glo_type'].includes(targetName)) return;
    var url = new URL(window.location.href);
    url.searchParams.set(targetName, value);
    window.history.replaceState(window.history.state, '', url.toString());
  };

  document.addEventListener('click', function (event) {
    // Allow the button, its image, or its text to activate the swatch
    var toggle = event.target.closest('.installer-swatch-toggle');
    if (!toggle) return;
    var form = toggle.closest('form');
    var targetName = toggle.dataset.target; //get the target input

    var target = targetName ? (form || document).querySelector('select[name="' + targetName + '"]') : false; //get the value

    var value = toggle.dataset.value; //if we have a target and a value...

    if (target && value) {
      //set the value of the target input
      target.value = value; //keep Fluent Forms conditions and validation in sync

      target.dispatchEvent(new Event('input', {
        bubbles: true
      }));
      target.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      setSwatchState(targetName, value, form || document);
      updateGloUrl(targetName, value);
    }
  }, false);
  document.addEventListener('click', function (event) {
    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('.ff-btn-submit')) return; //wait a few seconds

    setTimeout(function () {
      //fetch any error messages
      var errors = document.querySelectorAll('.error'); //if we have errors

      if (errors && errors.length > 0) {
        //scroll to the first error
        errors[0].scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 250);
  }); //attempt to get all the forms

  var forms = document.querySelectorAll('.installer-form-block form'); //if we have forms

  if (forms) {
    //loop through all forms
    forms.forEach(function (form) {
      //restore GLO choices directly from the URL before Fluent Forms evaluates the journey
      var url = new URL(window.location.href);
      ['glo_colour', 'glo_type'].forEach(function (targetName) {
        var target = form.querySelector('select[name="' + targetName + '"]');
        var value = url.searchParams.get(targetName);
        var hasOption = target && Array.from(target.options).some(function (option) {
          return option.value === value;
        });

        if (hasOption) {
          target.value = value;
          target.dispatchEvent(new Event('input', {
            bubbles: true
          }));
          target.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }); //synchronise accessible state for selections restored from the URL or quote cache

      form.querySelectorAll('.installer-swatch-toggle').forEach(function (toggle) {
        var target = form.querySelector('select[name="' + toggle.dataset.target + '"]');

        if (target && target.value) {
          setSwatchState(toggle.dataset.target, target.value, form);
        }
      }); //add an event listener to the form

      form.addEventListener('submit', function (event) {
        //toggle the loader
        toggle_loader(); //wait a few seconds and check if there are any errors within this form

        setTimeout(function () {
          //fetch any error messages
          var errors = form.querySelectorAll('.error'); //if we have errors

          if (errors && errors.length > 0) {
            //disable the loader
            disable_loader();
          }
        }, 250);
      });
    });
  }
});